export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/ce82aae38e929df8fcdd7e760ce92d73.svg";